import {
  absoluteUrl,
  canonicalUrl,
  formatPageTitle,
  toMetaDescription
} from "./chunk-G526BRWZ.mjs";
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_SHARE_IMAGE,
  DEFAULT_TITLE,
  OG_LOCALE,
  SITE_NAME
} from "./chunk-AFR26THN.mjs";

// src/types/seo/buildHeadTags.ts
var buildHeadTags = (meta, opts) => {
  const pageTitle = meta.title?.trim() || void 0;
  const description = meta.description && toMetaDescription(meta.description) || DEFAULT_DESCRIPTION;
  const url = canonicalUrl(opts.pathname);
  const shareTitle = pageTitle ?? DEFAULT_TITLE;
  const image = meta.image ? absoluteUrl(meta.image) : DEFAULT_SHARE_IMAGE.url;
  const imageAlt = meta.image ? shareTitle : DEFAULT_SHARE_IMAGE.alt;
  const noindex = opts.noindex || meta.noindex === true;
  const name = (key, content) => ({
    kind: "meta",
    attr: "name",
    key,
    content
  });
  const property = (key, content) => ({
    kind: "meta",
    attr: "property",
    key,
    content
  });
  const tags = [
    { kind: "title", text: formatPageTitle(pageTitle) },
    name("description", description),
    name("robots", noindex ? "noindex, nofollow" : "index, follow"),
    { kind: "link", rel: "canonical", href: url },
    property("og:type", meta.ogType ?? "website"),
    property("og:site_name", SITE_NAME),
    property("og:locale", OG_LOCALE),
    property("og:title", shareTitle),
    property("og:description", description),
    property("og:url", url),
    property("og:image", image)
  ];
  if (!meta.image) {
    tags.push(
      property("og:image:width", String(DEFAULT_SHARE_IMAGE.width)),
      property("og:image:height", String(DEFAULT_SHARE_IMAGE.height))
    );
  }
  tags.push(
    property("og:image:alt", imageAlt),
    name("twitter:card", "summary_large_image"),
    name("twitter:title", shareTitle),
    name("twitter:description", description),
    name("twitter:image", image),
    name("twitter:image:alt", imageAlt)
  );
  if (meta.jsonLd && (!Array.isArray(meta.jsonLd) || meta.jsonLd.length > 0)) {
    tags.push({ kind: "jsonld", json: meta.jsonLd });
  }
  return tags;
};

export {
  buildHeadTags
};
